'use client'

import { type ReactNode } from 'react'

import { Icon, IconComponent } from '@graftcode/design-system'

import { FILTERS_MOBILE_SHEET_TEST_IDS } from '@apps/service-map/service-map-test-ids.const'

import styles from './FiltersMobileSheet.module.scss'

export type SheetSelectRowProps = {
  rowLabel: string
  displayValue: string
  menuOpen: boolean
  onMenuOpenChange: (open: boolean) => void
  children: ReactNode
}

export function SheetSelectRow({ rowLabel, displayValue, menuOpen, onMenuOpenChange, children }: SheetSelectRowProps) {
  return (
    <>
      <button
        type="button"
        className={styles.row}
        data-testid={FILTERS_MOBILE_SHEET_TEST_IDS.selectRow}
        aria-expanded={menuOpen}
        onClick={() => onMenuOpenChange(!menuOpen)}
      >
        <span className={styles.rowLabel}>{rowLabel}</span>
        <span className={styles.rowValueWrap}>
          <span className={styles.rowValue}>{displayValue}</span>
          <IconComponent icon={Icon.ChevronUpDownRegular} className={styles.rowChevron} />
        </span>
      </button>
      {menuOpen ? <div className={styles.inlineMenuPanel}>{children}</div> : null}
    </>
  )
}
